import React, { Component } from 'react';
import { __n } from 'i18n-for-browser';
import Scrollbar from 'react-scrollbars-custom';

import Pictures from '../elements/Pictures.js';
import history from "../../history.js";

import GoBackButton from "../elements/GoBackButton";
import connect from "react-redux/es/connect/connect";

class ClassLeaderMedia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
    }
  }

  toggleTab = (no) => {
    this.setState({
      activeTab: no
    });
  };

  getTabPage = () => {
    let desktop = false;
    if (window.width > 1024) {
      desktop = true;
    }

    if (desktop) {
      return (
        <Scrollbar style={{ margin: "20px auto", width: '800px', height: '100%', minHeight: 300 }} >
          <Pictures history={history} />
        </Scrollbar>
      );
    }
    return <Pictures history={history} />;
  };

  render() {
    return (
      <div className="portal-home school-class-media class-leader-media darkBckg">
        <div className="desktop-content-center">
          <div className="buttonRow media classleader">
            <GoBackButton history={this.props.history} />
          </div>
        </div>
        {this.getTabPage()}
      </div>
    );
  }
}

export default connect(state => ({
  project: state.project
}))(ClassLeaderMedia);



// WEBPACK FOOTER //
// ./src/components/routes/ClassLeaderMedia.js